module.exports = __webpack_public_path__ + "img/65.2.TN.ec9a4970.png";